import React from 'react'
import BaseEducationTab from './BaseEducationTab'

export default function ExtracurricularActivities() {
  return <BaseEducationTab tabType="extracurricularActivities" />
}
